import React, { memo } from "react";
import Lottie from "lottie-react";
import loaderAnimation from '../../assets/lottie/flying-disc.json';
import css from "./Loader.module.css"

const FullLoader = ({message}) => {
  return (
    <div className={css.container}> 
    <div className={css.overlay}>
      <Lottie
        animationData={loaderAnimation}
        loop
        autoplay
        style={{ width:250, height: 200 }}
      />
      <p className={css.loadingText}>{message||"Finding discs for you"}<span className={css.loaderDots}></span></p>
    </div>
    </div>
  );
};






export default memo(FullLoader);